import usersApi from '@/api/identity/usersApi'
import { queryKeys } from '@/constant/common'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useAuthContext } from '../context'
import { IMyAccessControl } from '@/types/user'

const useMyAccessControl = (): UseQueryResult<IMyAccessControl, any> => {
  const { isLogin } = useAuthContext()

  return useQuery(
    [queryKeys.myAccessControl],
    async () => {
      const { data } = await usersApi.getMyAccessControl()

      return data
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: isLogin,
    },
  )
}

export default useMyAccessControl
